module.exports = __webpack_public_path__ + "img/xl_gz.6d6e30cb.png";